module.exports = __webpack_public_path__ + "static/media/concours-totalement-dt-fr.29383b2f.jpg";